
import styles from "./PartSurvey.module.scss";
import { useEffect, useState } from "react";
import PartSurveyItem from './PartSurveyItem/PartSurveyItem';
import SurveyChangeForm from "components/Forms/SurveyForm/SurveyChangeForm";
const PartSurvey = ({ id, setRender, partSurveySurveys }) => {

  const [edit_id, setEditId] = useState(null);

  const ChangeRowOn = (id) => {
    setEditId(id);
  }
  
  return (
    <div className={styles.test_card}>
      {partSurveySurveys.map((item, index) =>
        item.id !== edit_id ? (
          <PartSurveyItem
            item={item}
            index={index}
            setRender={setRender}
            MassLength={partSurveySurveys.length}
            ChangeRowOn={ChangeRowOn}
          />
        ) : (
          <SurveyChangeForm item={item} setRender={setRender} ChangeRowOn={ChangeRowOn} />
          
        )
      )}


    </div >

  );
};

export default PartSurvey;
